import React, { useRef, useEffect, useCallback, useState} from 'react';
import Sample from 'repos/Sample.js';
import ipfs from 'decentralized/Ipfs.js';
import Colors from 'components/Colors.js';
import {
    setShowingSoundList,
    setCurrentSoundInList} from 'actions/index.js';
import SampleOption from './SampleOption.js';
import {useScroll} from './useScroll.js';
import {connect} from 'react-redux';
const colors = new Colors();

const SourceResults = ({
    setCurrentSoundInList,
    setShowingSoundList,
    source,
    resultsCounter=0,
    sequencerEngine,
    odd,
    alone,
    resultsSize,
    i,
    showPianoRoll,
    scrollRef,
    bottomHeight,
    isPack,
    packToSearch,
    isUnsourced,
    setSearchTerm,
    currentSoundInList,
    sourceToSearch,
    loadEverything,
    setPackToSearch,
}) => { 
    let {coverArtHash, results, videoId, tag} = source;
    let [samples, setSamples] = useState([]);
    let [autoLoad, setAutoLoad] = useState(alone || loadEverything)
    let ref = useRef(undefined);
    let {size} = useScroll(ref, 9, alone, undefined, undefined, undefined, sourceToSearch);

    useEffect(() => {
    }, [size]);

    useEffect(() => {
        setShowingSoundList(true);
        return () => {
            setCurrentSoundInList(undefined);
            setShowingSoundList(false);
        }
    }, []);

    let style = {
    };
    if (!sourceToSearch && coverArtHash) {
        style.backgroundImage = 'url(' + ipfs.getHashUrl(coverArtHash) + ")";
    } else if (!sourceToSearch && videoId) {
        style.backgroundImage = 'url(' + 'https://img.youtube.com/vi/' + videoId + '/1.jpg)';
    } else if (tag) {
        /*
        style.borderColor = colors.getColorForHash(tag);
        style.borderStyle = "solid";
        style.borderWidth = 1;
        style.color = style.borderColor;
        */
        style.backgroundColor = colors.getColorForHash(tag);
    }

    let thumbClassName = "source-results-thumb";
    if (tag) {
        thumbClassName += " unsourced";
    }

    let className = "source-results";
    if (odd) {
        className += " odd";
    }
    if (alone) {
        className += " alone";
    }
    /*
    if (!alone && resultsSize === 0)  {
        return (<div></div>);
    }
    */

    let fullStyle = {
    };
    if (alone) {
        fullStyle.height= window.innerHeight - 233
    }
    if(showPianoRoll) {
        fullStyle.height -= bottomHeight - 130;
    }
    let releaseName = results[0].releaseName;
    let artistName = results[0].artistName;

    return (
        <div style={fullStyle}
             ref={ref}
             className={className}>
          <div
            onClick={() => setAutoLoad(true)}
            className={thumbClassName} style={style}>
            <span>{tag}</span>
          </div>
          <div className="sample-options">
            {!sourceToSearch && releaseName ? <div className="release-name">{artistName} - {releaseName}</div> : ''}
            {results.slice(0, resultsSize !== undefined ? resultsSize : size).map(
                (x,i) =>
                    <SampleOption
                      isUnsourced={isUnsourced}
                      setPackToSearch={setPackToSearch}
                      scrollRef={scrollRef}
                      isCurrent={(!packToSearch || isPack) && resultsCounter + i === currentSoundInList}
                      isNext={resultsCounter + i === currentSoundInList + 1}
                      number={resultsCounter + i}
                      setSearchTerm={setSearchTerm}
                      autoLoad={autoLoad}
                      source={coverArtHash || videoId || tag}
                      sequencerEngine={sequencerEngine}
                      key={i}
                      result={x}/>)}
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight,
      currentSoundInList: state.selector.currentSoundInList //state.selector.currentSoundInList >= props.resultsCounter &&
          //state.selector.currentSoundInList < props.resultsCounter + props.resultsSize ?
          //state.selector.currentSoundInList : undefined,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setCurrentSoundInList: m => dispatch(setCurrentSoundInList(m)),
      setShowingSoundList: m => dispatch(setShowingSoundList(m))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceResults);
